import { Form, Switch } from "antd";
import React from "react";

const AdditionalReports: React.FC = () => {
  return (
    <Form.Item name="hasAdditionalReports" label="Allow Additional Reports?">
      <Switch />
    </Form.Item>
  );
};

export default AdditionalReports;
